var map = {
	"./default.png": 1055,
	"./down.png": 1056,
	"./empty.png": 1057,
	"./hide-navigation.png": 1058,
	"./left.png": 1059,
	"./logo_pieni.png": 1060,
	"./map-layer-button-3d-dark.png": 1061,
	"./map-layer-button-3d-light.png": 1062,
	"./map-layer-button-rounded-dark.png": 1063,
	"./map-layer-button-rounded-light.png": 1064,
	"./map-layer-button-sharp-dark.png": 1065,
	"./map-layer-button-sharp-light.png": 1066,
	"./marker.png": 1067,
	"./menu-3d-dark.png": 1068,
	"./menu-3d-light.png": 1069,
	"./menu-rounded-dark.png": 1070,
	"./menu-rounded-light.png": 1071,
	"./menu-sharp-dark.png": 1072,
	"./menu-sharp-light.png": 1073,
	"./mobile-my-location-dark.png": 1074,
	"./mobile-my-location-light.png": 1075,
	"./myplaces-draw-area-dark.png": 1076,
	"./myplaces-draw-area-light.png": 1077,
	"./myplaces-draw-line-dark.png": 1078,
	"./myplaces-draw-line-light.png": 1079,
	"./myplaces-draw-point-dark.png": 1080,
	"./myplaces-draw-point-light.png": 1081,
	"./oskari_icon.png": 1082,
	"./panbutton-sprites-3d-dark.png": 1083,
	"./panbutton-sprites-3d-light.png": 1084,
	"./panbutton-sprites-rounded-dark.png": 1085,
	"./panbutton-sprites-rounded-light.png": 1086,
	"./panbutton-sprites-sharp-dark.png": 1087,
	"./panbutton-sprites-sharp-light.png": 1088,
	"./pti_icon.png": 1089,
	"./right.png": 1090,
	"./root.png": 1091,
	"./search-tool-3d-dark_01.png": 1092,
	"./search-tool-3d-dark_02.png": 1093,
	"./search-tool-3d-dark_03.png": 1094,
	"./search-tool-3d-light_01.png": 1095,
	"./search-tool-3d-light_02.png": 1096,
	"./search-tool-3d-light_03.png": 1097,
	"./search-tool-rounded-dark_01.png": 1098,
	"./search-tool-rounded-dark_02.png": 1099,
	"./search-tool-rounded-dark_03.png": 1100,
	"./search-tool-rounded-light_01.png": 1101,
	"./search-tool-rounded-light_02.png": 1102,
	"./search-tool-rounded-light_03.png": 1103,
	"./search-tool-sharp-dark_01.png": 1104,
	"./search-tool-sharp-dark_02.png": 1105,
	"./search-tool-sharp-dark_03.png": 1106,
	"./search-tool-sharp-light_01.png": 1107,
	"./search-tool-sharp-light_02.png": 1108,
	"./search-tool-sharp-light_03.png": 1109,
	"./show-navigation.png": 1110,
	"./sprite.png": 1111,
	"./suomi25m_tm35fin.png": 1112,
	"./tool-history-back-dark.png": 1113,
	"./tool-history-back-light.png": 1114,
	"./tool-history-forward-dark.png": 1115,
	"./tool-history-forward-light.png": 1116,
	"./tool-measure-area-dark.png": 1117,
	"./tool-measure-area-light.png": 1118,
	"./tool-measure-line-dark.png": 1119,
	"./tool-measure-line-light.png": 1120,
	"./tool-zoombox-dark.png": 1121,
	"./tool-zoombox-light.png": 1122,
	"./up.png": 1123,
	"./world_dark.svg": 1124,
	"./world_light.svg": 1125,
	"./zoombar-3d-dark.png": 1126,
	"./zoombar-3d-light.png": 1127,
	"./zoombar-cursor-3d-dark.png": 1128,
	"./zoombar-cursor-3d-light.png": 1129,
	"./zoombar-cursor-rounded-dark.png": 1130,
	"./zoombar-cursor-rounded-light.png": 1131,
	"./zoombar-cursor-sharp-dark.png": 1132,
	"./zoombar-cursor-sharp-light.png": 1133,
	"./zoombar-rounded-dark.png": 1134,
	"./zoombar-rounded-light.png": 1135,
	"./zoombar-sharp-dark.png": 1136,
	"./zoombar-sharp-light.png": 1137,
	"./zoombar.png": 1138,
	"./zoombar_cursor.png": 1139,
	"./zoombar_minus-3d-dark.png": 1140,
	"./zoombar_minus-3d-light.png": 1141,
	"./zoombar_minus-patched.png": 1142,
	"./zoombar_minus-rounded-dark.png": 1143,
	"./zoombar_minus-rounded-light.png": 1144,
	"./zoombar_minus-sharp-dark.png": 1145,
	"./zoombar_minus-sharp-light.png": 1146,
	"./zoombar_minus.png": 1147,
	"./zoombar_minus_mobile.png": 1148,
	"./zoombar_plus-3d-dark.png": 1149,
	"./zoombar_plus-3d-light.png": 1150,
	"./zoombar_plus-rounded-dark.png": 1151,
	"./zoombar_plus-rounded-light.png": 1152,
	"./zoombar_plus-sharp-dark.png": 1153,
	"./zoombar_plus-sharp-light.png": 1154,
	"./zoombar_plus.png": 1155,
	"./zoombar_plus_mobile.png": 1156,
	"./zoombar_plus_patched.png": 1157
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1054;